import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import EventFeed from "@/components/dashboard/EventFeed";
import { listEvents } from "@/lib/api";
import { RefreshCw, Filter } from "lucide-react";

export default function LiveEvents() {
    const { liveEvents = [] } = useOutletContext() || {};
    const [events, setEvents] = useState([]);
    const [severity, setSeverity] = useState("all");
    const [search, setSearch] = useState("");

    const load = async () => {
        const params = { limit: 100 };
        if (severity !== "all") params.severity = severity;
        const data = await listEvents(params);
        setEvents(data.events || []);
    };

    useEffect(() => {
        load();
        const t = setInterval(load, 15000);
        return () => clearInterval(t);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [severity]);

    const live = liveEvents.filter((m) => m.type === "event").map((m) => m.data);
    const merged = [...live, ...events]
        .filter((e, idx, arr) => arr.findIndex((x) => x.id === e.id) === idx)
        .filter((e) =>
            search
                ? (e.reason || "").toLowerCase().includes(search.toLowerCase()) ||
                  (e.event_type || "").includes(search.toLowerCase()) ||
                  (e.chat_title || "").toLowerCase().includes(search.toLowerCase())
                : true,
        );

    return (
        <div className="space-y-4 md:space-y-6">
            <div>
                <h1 className="text-2xl md:text-3xl font-semibold tracking-tight">
                    الأحداث المباشرة
                </h1>
                <p className="mt-1 text-sm text-muted-foreground">
                    سجل لحظي لكل إجراء يقوم به Guardian Pro
                </p>
            </div>

            <Card className="bg-card/60 backdrop-blur">
                <CardHeader>
                    <div
                        className="flex flex-wrap items-center gap-2"
                        data-testid="live-feed-filters"
                    >
                        <Filter className="h-4 w-4 text-muted-foreground" />
                        <Select value={severity} onValueChange={setSeverity}>
                            <SelectTrigger className="w-[160px]" data-testid="live-feed-severity-select">
                                <SelectValue placeholder="الخطورة" />
                            </SelectTrigger>
                            <SelectContent>
                                <SelectItem value="all">الكل</SelectItem>
                                <SelectItem value="critical">حرج</SelectItem>
                                <SelectItem value="warning">تحذير</SelectItem>
                                <SelectItem value="info">معلومات</SelectItem>
                                <SelectItem value="safe">آمن</SelectItem>
                            </SelectContent>
                        </Select>
                        <Input
                            placeholder="بحث…"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="w-[200px]"
                            data-testid="live-feed-search-input"
                        />
                        <Button
                            size="sm"
                            variant="outline"
                            onClick={load}
                            className="gap-2"
                            data-testid="live-feed-refresh-button"
                        >
                            <RefreshCw className="h-4 w-4" />
                            تحديث
                        </Button>
                    </div>
                </CardHeader>
                <CardContent>
                    <EventFeed events={merged} height="h-[640px]" />
                </CardContent>
            </Card>
        </div>
    );
}
